import PrescriptionsPatientsList from './prescriptions-patient-list';

export default PrescriptionsPatientsList;
